enum NetworkStatus {
  DOWN = 0,
  UP,
}

export default NetworkStatus;
